/**
 * SEO utilities for MercadoLibertario
 */

/**
 * Convert a string to a URL-friendly slug.
 * "Mesa de madera artesanal!" → "mesa-de-madera-artesanal"
 */
export function slugify(text) {
  return (text || '')
    .toString()
    .normalize('NFD')                   // decompose accents
    .replace(/[\u0300-\u036f]/g, '')    // remove accent marks
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')       // non-alphanumeric → hyphen
    .replace(/^-+|-+$/g, '')           // trim leading/trailing hyphens
    .substring(0, 80);                  // limit length
}

/**
 * Build a SEO-friendly product URL: /producto/mesa-de-madera-artesanal-42
 * The ID is always the last segment after the final hyphen.
 */
export function productUrl(product) {
  const id = product.id || product.productId;
  const title = product.title || product.productTitle || '';
  const slug = slugify(title);
  return slug ? `/producto/${slug}-${id}` : `/producto/${id}`;
}

/**
 * Extract the product ID from a SEO slug.
 * "mesa-de-madera-artesanal-42" → "42"
 */
export function extractIdFromSlug(slug) {
  if (!slug) return null;
  const lastDash = slug.lastIndexOf('-');
  if (lastDash === -1) return slug; // bare ID
  return slug.substring(lastDash + 1);
}
